import {ProductApi} from "@core/api";

export default {
    methods: {
        downloadProductDocument(productId, document) {
            return new Promise((resolve, reject) => {
                ProductApi
                    .downloadDocument(productId, document.id)
                    .then(response => {
                        this.__makeDownloadLinkAndClick(document, response.data);

                        resolve();
                    })
                    .catch(reject);
            });
        },
        downloadRepliedDocument(requestId, document) {
            return new Promise((resolve, reject) => {
                ProductApi
                    .downloadRepliedDocument(requestId, document.id)
                    .then(response => {
                        this.__makeDownloadLinkAndClick(document, response.data);

                        resolve();
                    })
                    .catch(reject);
            });
        },

        __makeDownloadLinkAndClick(document, data) {
            const fileURL = window.URL.createObjectURL(new Blob([data]));
            const fileLink = window.document.createElement('a');

            fileLink.href = fileURL;
            fileLink.setAttribute('download', document.file.name);
            window.document.body.appendChild(fileLink);

            fileLink.click();
        }
    }
};
